import { useSnackbar } from "notistack";
import { useCallback, useState } from "react";

import { AjaxResult } from "../../../../../enums/ajaxResult";
import { useApi } from "../../../../useApi";

export function useSaveNotes(boxId: number) {
    const { boxApi } = useApi();
    const { enqueueSnackbar } = useSnackbar();
    const [loading, setLoading] = useState(false);

    const saveNotes = useCallback((notes: string, onSuccess: () => void) => {
        setLoading(true);
        boxApi.setNotes(boxId, notes).then((r) => {
            if (r.result !== AjaxResult.Success) {
                enqueueSnackbar("Failed to save box notes!", { variant: "error" });
            } else {
                enqueueSnackbar("Box notes saved!", { variant: "success" });
                onSuccess();
            }
            setLoading(false);
        });
    }, [boxApi, boxId, enqueueSnackbar]);

    return { saveNotes, loading }
}